<template>
  <div class="table-summary">
		<div>
			<div class="table-summary-header">
				<div class="center">
					<span class="table-summary-title"
						:style="`color:${$appColors.info}`"
					>{{data.name}}</span>
				</div>
				<div class="d-center">
					<button class="d-center" @click="$emit('action', data )">
						<img
							src="/static/img/diagnosis/eye.svg"
							alt="detalle"
							height="18"
						/>
					</button>
				</div>
			</div>
			<table class="table-summary-questions"
				:style="`color:${$appColors.info}`"
			>
				<thead :style="`color:${$appColors.primary}`">
					<tr class="border-head" :style="`boder-color:${$appColors.primary}`">
						<th>Preguntas</th>
						<th>Valor</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in children" :key="index">
						<td
							class="question-columns"
							:title="item.name"
							:style="`border-color: ${$appColors.primary}`"
						>
							{{index + 1}}
						</td>
						<td class="value-columns">{{item.value}}</td>
					</tr>
				</tbody>
				<tfoot>
					<tr class="white">
						<td
							class="center border-footer"
							colspan="2"
							:style="`boder-color:${$appColors.primary};color:${$appColors.primary}`"
						>Total: <span class="bold">{{data.value}}</span></td>
					</tr>
				</tfoot>
			</table>
		</div>
	</div>
</template>
<script>

function children() {
	return this.data.entities.sort((a, b) => a.hierarchyId - b.hierarchyId);
}

export default {
	name: 'table-summary',
	computed: {
		children,
	},
	props: {
		data: {
			type: Object,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
	.table-summary {
		background: color(white);
		border-radius: 4px;
		box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
		margin: auto;

		.table-summary-header {
			align-items: center;
			display: flex;
			justify-content: space-between;
			padding: 1.5px 7px;
		}

		&-title {
			font-family: font(bold);
			font-size: 11px;
			white-space: nowrap;
		}

		&-questions {
			border-collapse: collapse;
			font-size: 10px;
			width: 100%;
		}

		td {
			text-align: center;
		}

		.border-head th {
			border-bottom: 0.6px solid;
			border-top: 0.6px solid;
			font-family: font(regular) !important;
			font-weight: 500 !important;
		}

		tbody {
			tr:nth-child(even) {
				background: color(table-gray);
			}

			tr {
				td:first-child {
					border-right: 1px solid color(primary);
					width: 50%;
				}
			}
		}

		.border-footer {
			border-top: 1px solid;
		}

		.bold {
			font-family: font(bold);
		}

		.d-center {
			align-items: center;
			display: flex;
			justify-content: center;
		}
	}

	.question-columns,
	.value-columns {
		color: color(tooltip-gray);
		font-family: font(regular) !important;
	}
</style>





// WEBPACK FOOTER //
// src/components/diagnosis/table-summary.vue